import {
  GbApiRequestService,
  withSchemaValidation,
} from "@/services/ApiRequestService";

import { FavouritesQueryParams, FavouritesResponseDTO } from "./models";

export class FavouriteApi {
  static sendAction = async (params: FavouritesQueryParams) => {
    const response = GbApiRequestService.post("userRpc", null, {
      params: {
        type: JSON.stringify({
          dataMap: params,
          processorClass: "Favorites",
        }),
      },
    });

    return await withSchemaValidation(response, FavouritesResponseDTO);
  };
}
